const hosts = require('../../config/hosts.js')
const state = {
  user: {
    name: '',
    id: ''
  },
  wx_baseUrl: hosts.WX_HOST,
  zbz_baseUrl: hosts.ZBZ_HOST,
  jx_baseUrl: hosts.JX_HOST,
  ldy_baseUrl: hosts.LDY_HOST,
  top_baseUrl: hosts.TOP_HOST,
  gj_baseUrl: hosts.GJ_HOST,
};

export default state;



// WEBPACK FOOTER //
// ./src/store/state.js